export descriptions = {
  default:
    primary: 'There is currently no description for this service'
    secondary: 'Please contact a project administrator to learn more about this service'
  clearSpace:
    primary: "Clears the space"
    secondary: "Wipes the space of all nodes, relations and attributes"
  rawXl:
    primary: "Uploads an excel"
    secondary: "A spreadsheet is a file that exists of cells in rows and columns and can help arrange, calculate and sort data. Data in a spreadsheet can be numeric values, as well as text, formulas, references and functions"
  rawCsv:
    primary: "Uploads a CSV file"
    secondary: "A comma-separated values file is a delimited text file that uses a comma to separate values. Each line of the file is a data record. Each record consists of one or more fields, separated by commas."
  rawXml:
    primary: "Uploads an XML"
    secondary: "Extensible Markup Language is a markup language that defines a set of rules for encoding documents in a format that is both human-readable and machine-readable"
  rawJson:
    primary: "Uploads a JSON"
    secondary: "JavaScript Object Notation is an open standard file format, and data interchange format, that uses human-readable text to store and transmit data objects consisting of attribute–value pairs and array data types"
  trig:
    primary: 'Uploads a Trig file'
    secondary: 'TriG is a serialization format for RDF (Resource Description Framework) graphs. It is a plain text format for serializing named graphs and RDF Datasets which offers a compact and readable alternative to the XML-based TriX syntax'
  yamlToRdfs:
    primary: 'Uploads a yml file'
    secondary: 'YAML is a human-readable data-serialization language. It is commonly used for configuration files and in applications where data is being stored or transmitted. YAML targets many of the same communications applications as Extensible Markup Language but has a minimal syntax which intentionally differs from SGML.'
  relaticsStream:
    primary: 'Uploads a Relatics XML'
    secondary: 'Relatics is a cloud-based platform used in the civil, infrastructure and construction engineering industries for systems engineering, requirements management and project management. Relatics allows users to manage contracts and change orders, bids, tasks, subcontractors and permits'
  bim360:
    primary: 'Uploads a BIM360 JSON'
    secondary: 'BIM 360™ Build is a cloud-based field management service for construction professionals combining a mobile application at the point of construction with collaboration and reporting'
  weaverTransform:
    primary: 'Transforms a yaml file'
    secondary: ''
  turtle:
    primary: 'Generates a Turtle file'
    secondary: 'Terse RDF Triple Language (Turtle) is a syntax and file format for expressing data in the Resource Description Framework (RDF) data model. It is a common data format for storing RDF data, along with N-Triples, JSON-LD and RDF/XML.'
  rdfExport:
    primary: 'Exports a Resource Description Framework file'
    secondary: 'RDF is a standard model for data interchange on the Web. RDF has features that facilitate data merging even if the underlying schemas differ, and it specifically supports the evolution of schemas over time without requiring all the data consumers to be changed.'
  predict:
    primary: 'Makes a prediction'
    secondary: 'The output of an algorithm after it has been trained on a historical dataset and applied to new data when forecasting the likelihood of a particular outcome.
      The training ID from a completed training action must be provided when making a prediction.'
  train:
    primary: 'Trains the model'
    secondary: 'Training a model, determines the good values for all the weights and the bias from labeled examples.
      In order to train a model, provide a training ID and fill in the required fields. For help, click the ? icons.'
  getStatus:
    primary: 'Gets status of ongoing or completed training tasks.'
    secondary: 'In order to get the status of the the task, select an existing training ID from the dropdown menu.'
}
